import React from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'antd';
import Loader from 'components/Loading/Loader';

interface WaitModalProps {
    message?: string;
}

const WaitModal: React.FC<WaitModalProps> = ({ message }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={true}
            maskClosable={true}
            closable={false}
            okButtonProps={{ style: { display: 'none' } }}
            footer={null}
            title={t("messages.please_wait")}
        >
            <Loader size={100} style={{ minHeight: "70px" }} />
            <div className="text-center mb-2">
                {message || t("models.project.messages.clone_in_progress")}
            </div>
        </Modal>
    );
};

export default WaitModal;
